module.exports = __webpack_public_path__ + "img/5.Ford2018.6b34ee80.png";